import SimCards from "./SimCards";

export default SimCards;
